// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dkJU","col":"styles_col__1Ws55"};